import mime from 'mime/lite';

import { IS_WEB } from './platform';

/**
 * Creates new File Object
 * @param {string} uri
 * @param {string} name
 * @returns {object}
 */
export function getFileObject(uri: string, name: string) {
  const type = mime.getType(uri);
  return {
    uri,
    type,
    name,
  };
}

/**
 * "Web" only util. For "Mobile" use getFileObject
 * For "web" we need to detect if the URI is base64,
 * and convert it to a blob
 *
 * @param {string} base64
 * @returns {Promise<Blob>}
 */
export async function convertBase64ToBlob(base64: string) {
  const response = await fetch(base64);
  return response.blob();
}

/**
 * Provides a way to easily construct a set of key/value pairs representing
 * form fields and their values,
 * which can then be easily sent data to back-end side.
 * It uses the same format a form would use if the encoding type were set
 *
 * @param {string} uri
 * @param {string} name
 * @returns {FormData}
 */
export async function formData(uri: string, name: string) {
  const formedData = new FormData();

  const fileData = IS_WEB
    ? await convertBase64ToBlob(uri)
    : getFileObject(uri, name);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  formedData.append(name, fileData);

  return formedData;
}
